function isTouchDevice() {
  let bool = false;

  if ('ontouchstart' in document.documentElement) {
    bool = true;
  }

  return bool;
}


window.isTouchDevice = isTouchDevice;
